export const EVT_SESSION_END = 'session_end';
export const EVT_SESSION_START = 'session_start';
export const EVT_PLAY = 'play';
export const EVT_PAUSE = 'pause';
export const EVT_READY = 'ready';
export const EVT_ENDED = 'ended';
export const EVT_CTA_CLICK = 'cta';
export const EVT_VIEW = 'view';
export const EVT_RATE_CHANGE = 'rate-change';
